<template>
  <v-dialog
      @click:outside="closeEstimationDialog()"
      content-class="rounded-xl dialog-right"
      :retain-focus="false"
      v-model="estimation"
      :scrollable="false"
      width="1000px"
  >
    <v-card
        class="rounded-xl"
        height="100%"
        outlined
        min-width="100%"
        tile
    >
      <v-card-title>
        <v-row no-gutters>
          <v-col cols="12" class="d-flex justify-end">
            <v-btn
                icon
                @click="closeEstimationDialog()"
            >
              <v-icon size="20">
                fa-times
              </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" class="d-flex justify-center text-h5">
            Оценка ЭУК
          </v-col>
          <v-tabs
              v-model="tab_index_appraiser"
              centered
              slider-color="teal"
              active-class="teal--text"
          >
            <v-tab
                @click="setCommentForRole(role.key)"
                v-for="role in roles"
                :key="role.key"
            >
              {{ role.name }}
            </v-tab>
          </v-tabs>
        </v-row>
      </v-card-title>
      <v-card-text style="height: calc(100% - 138px);">
        <v-tabs-items style="height: 100%" v-model="tab_index_appraiser">
          <v-tab-item
              style="height: 100%"
              v-for="role in roles"
              :key="role.key"
          >
            <v-card
                class="overflow-hidden rounded-xl"
                height="100%"
                outlined
                tile
            >
              <v-card-text style="height: 100%" class="ma-0 pa-0">
                <v-window
                    style="height: 100%"
                    v-model="window_index_conf"
                    :hide-slider="true"
                >
                  <v-window-item style="height: 100%">
                    <TableListComments
                        :role_key="role.key"
                        :window_index_conf="window_index_conf"
                        :definition_role="definition_role"
                        :selected_tech_map="selected_tech_map"
                        @setIndexWindowFormComment="setIndexWindowFormComment"
                    />
                  </v-window-item>
                  <v-window-item style="height: 100%">
                    <CardEstimationMethodologist
                        v-if="role.key === 3"
                        :selected_tech_map="selected_tech_map"
                        @closeWindowEstimation="closeWindowEstimation"
                    />
                    <CardEstimation
                        v-else
                        :role_key="role.key"
                        :selected_tech_map="selected_tech_map"
                        @closeWindowEstimation="closeWindowEstimation"
                    />
                  </v-window-item>
                </v-window>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapState} from "vuex";
import CardEstimation from "../Cards/CardEstimation";
import CardEstimationMethodologist from "../Cards/CardEstimationMethodologist";
import _ from "lodash";
import TableListComments from "../Tables/TableListComments.vue";

export default {
  name: "DialogEstimationTechMap",
  props: {
    estimation: {
      type: Boolean
    },
    selected_tech_map: {
      type: Object
    }
  },
  components: {
    TableListComments,
    CardEstimation,
    CardEstimationMethodologist
  },
  data: () => ({
    drawer: false,
    drawer_repeat: false,
    window_index_conf: 0,
    tab_index_appraiser: 0
  }),
  mounted() {
  },
  computed: {
    ...mapState({
      list_comments: state => state.studyEstEukTechMapCommission.list_comments,
    }),
    definition_role() {
      return _.findIndex(this.selected_tech_map?.definition_roles?.roles, (role) => {return role.key === 3}) !== -1
    },
    roles(){
      return this.selected_tech_map?.definition_roles?.roles
    }
  },
  watch: {
    estimation(value) {
      if (value) {
        if (!this.list_comments.length > 0) {
          this.window_index_conf = 1
        }
      }
    }
  },
  methods: {
    ...mapActions({
      updateCommissionStatus: 'studyEstEukTechMapCommission/updateCommissionStatus',
      getCommissionStatuses: 'studyEstEukTechMapCommission/getCommissionStatuses',
    }),
    closeEstimationDialog() {
      this.$emit('closeEstimationDialog')
    },
    closeWindowEstimation() {
      this.window_index_conf = 0
    },
    setIndexWindowFormComment(props){
      this.window_index_conf = props.window_index_conf
    },
    async setCommentForRole(role_key){
     await this.getCommissionStatuses(
          {
            technological_map_id: this.selected_tech_map.id,
            role_key: role_key
          }
      )

      if (this.list_comments.length > 0){
        this.window_index_conf = 0
      } else this.window_index_conf = 1
    }
  }
}
</script>

<style scoped>
>>> .dialog-right {
  position: absolute;
  height: 100%;
  top: 0;
  right: 0;
}
</style>